/**
 * Machine-ID Redux slice.
 *
 * Stores the hardware UUID retrieved from the Tauri backend.
 * Sent with every login request for per-device licensing enforcement.
 * Preserved across logout (see root reducer) to avoid extra IPC calls.
 */
import { createSlice } from "@reduxjs/toolkit";

/** Shape of the machine-ID state tree. */
export interface MachineIdState {
  machineId: string;
}

const initialMachineIdState: MachineIdState = {
  machineId: "",
};

export const machineIdSlice = createSlice({
  name: "machineId",
  initialState: initialMachineIdState,
  reducers: {
    machineIdReducer: (state, action) => {
      state.machineId = action.payload.machineId;
    },
  },
});

export const { machineIdReducer } = machineIdSlice.actions;
export default machineIdSlice.reducer;
